export const DateFormats = {
    ['YYYY-MM-DDTHH:mm:ss']: 'YYYY-MM-DDTHH:mm:ss',
    ['DD/MM/YYYY']: 'DD/MM/YYYY',
    ['MM/DD/YYYY']: 'MM/DD/YYYY',
    ['DD-MM-YYYY']: 'DD-MM-YYYY',
    ['DD/MM/YYYYTHH:mm:ss']: 'DD/MM/YYYYTHH:mm:ss',
    ['YYYY-MM-DD']: 'YYYY-MM-DD',
    ['HH:mm']: 'HH:mm',
    ['HH:mm:ss']: 'HH:mm:ss',
    ['DD/MM/YYYY HH:mm']: 'DD/MM/YYYY HH:mm',
    ['MMMM YYYY']: 'MMMM YYYY',
    ['MMMM DD, YYYY']: 'MMMM DD, YYYY',
    ['dddd, DD/MM']: 'dddd, DD/MM',
    ['ddd MMM DD YYYY HH:mm:ss [GMT]ZZ']: 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ',
};
